import React from "react";

import { GridResult } from "2g-grid";

import useProduktyGrid from "./useProduktyGrid";

export function ProduktyGrid() {
  const grid = useProduktyGrid();
  return <GridResult {...grid} />;
}

ProduktyGrid.propTypes = {};

export default React.memo(ProduktyGrid);
